<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.ADD') }}
            {{ $t('ABO_SERVICES.ITEM') }}
          </span>
        </v-toolbar-title>

        <v-spacer />

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider />
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <abo-services-form
            v-model="form"
            :errors="errors.getAll()"
            @update-prop="clearErrorByName($event)"
          >
            <template v-slot:buttons>
              <v-btn
                normal
                class="float-right"
                color="primary"
                :disabled="!valid"
                @click="submit"
                >{{ $t('BUTTON.SAVE') }}</v-btn
              >
            </template>
          </abo-services-form>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import AboServicesForm from '@/modules/abo_services/components/AboServicesForm';
import { AboServicesService } from '@/services/abo-services.service';

export default {
  name: 'AboServiceCreatePage',

  components: {
    AboServicesForm
  },

  mixins: [errors],

  data: () => {
    return {
      valid: false,
      form: {}
    };
  },

  methods: {
    save() {
      AboServicesService.create(this.form)
        .then(() => {
          this.$router.push({ name: 'abo-services' });
        })
        .catch(this.handleErrors);
    },

    submit() {
      this.errors.clear();
      this.save();
    }
  }
};
</script>
